import { jsx, jsxs } from "react/jsx-runtime";
import { FormFooter } from "../../../FormFooter.js";
import { LoginPrimaryAction } from "../../../LoginPrimaryAction/index.js";
import { useAutoFocusEmptyField } from "../../hooks/useAutoFocusEmptyField.js";
import { useResetPasswordValidation } from "../../hooks/useResetPasswordValidation.js";
import { resetPasswordForm } from "../../resetPasswordFormSetup.js";
import { useTexts } from "./useTexts.js";
function ResetPasswordFooter(props) {
  const {
    silentErrors = false,
    buttonProps,
    validationSummaryItems: externalValidationSummaryItems,
    mode,
    autoFocus: autofocusStatus,
    showRepeatPassword,
    footerProps = {}
  } = props;
  const {
    meta: { submitting }
  } = resetPasswordForm.useFormMeta();
  const texts = useTexts();
  const validationSummaryItems = useResetPasswordValidation(mode, externalValidationSummaryItems);
  const validationSummaryMode = silentErrors ? "silent-errors" : "show-errors";
  const autoFocusField = useAutoFocusEmptyField(autofocusStatus, showRepeatPassword);
  const autoFocus = autoFocusField === "submit";
  return /* @__PURE__ */ jsxs(FormFooter, { sx: { flexDirection: "column", ...footerProps }, children: [
    /* @__PURE__ */ jsx(resetPasswordForm.ValidationSummary, { items: validationSummaryItems, mode: validationSummaryMode }),
    /* @__PURE__ */ jsx(
      LoginPrimaryAction,
      {
        label: texts.reset,
        testId: "ResetPasswordBtn",
        disabled: submitting,
        autoFocus,
        componentProps: buttonProps
      }
    )
  ] });
}
export {
  ResetPasswordFooter
};
//# sourceMappingURL=ResetPasswordFooter.js.map
